import { IComponentOptions } from 'angular';
import { ClassOfDropdownCtrl } from './class-of-dropdown.controller';

export const ClassOfDropdownComponent: IComponentOptions = {
  controller: ClassOfDropdownCtrl,
  template: require('./class-of-dropdown.html'),
};
